<template>
  <div class="sdg-panel-row">
    <div class="sdg-panel-row__sector">{{ sector }}</div>

    <div class="sdg-panel-row__sdgs">
      <img
        v-for="goalNr of SDGs"
        :key="'goal-' + goalNr"
        class="sdg-panel-row__sdgs__sdg"
        :src="`${$baseUrl}images/SDGs/goal-${goalNr}.webp`"
        alt=""
      />
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";

defineProps({
  sector: String,
  SDGs: {
    type: Array,
    default: () => [],
  },
});

const $baseUrl = inject("$baseUrl");
</script>

<style lang="scss" scoped>
.sdg-panel-row {
  display: flex;
  align-items: center;
  padding: 0.5rem 0;
  
  &:not(:last-child) {
    border-bottom: 1px solid var(--white-25);
  }

  &__sector {
    @include dida-s;

    width: var(--column-1-width);
    padding-right: 1.5rem;
  }

  &__sdgs {
    display: flex;
    gap: 0.5rem;

    &__sdg {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
}
</style>
